enum DateFormatTypeEnum {
  DATE,
  DATETIME,
}

export default DateFormatTypeEnum;
